module.exports = __webpack_public_path__ + "static/sinmoji-f477ef565c58b0ea4a6f482a230cf772.png";